import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text19 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {rightsPermitCompanyMeshakenet} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(rightsPermitCompanyMeshakenet) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <div className={styles.bold}>אישור זכויות חברה משכנת: </div>
          <span>{getBreakLinesTextShumaType3(rightsPermitCompanyMeshakenet)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text19;
